import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <nav className="footer-links">
          <Link to="/" className="pill red">Home</Link>
          <Link to="/stgilesdonate" className="pill yellow">St Giles Donate</Link>
          <Link to="/woodenspoondonate" className="pill red">Wooden Spoon Donate</Link>
          <Link to="/amount-raised" className="pill yellow">Amount Raised</Link>
          <Link to="/gallery" className="pill red">Gallery</Link>
          <Link to="/our-story" className="pill yellow">Our Story</Link>
        </nav>
      </div>
      <div className="footer-policy-container">
        <Link to="/policies" className="footer-policy-link">
        Policies
        </Link>
        </div>
      <div className="tribute">
        In loving memory of Beth Branson — forever in our hearts 💛
      </div>
    </footer>
  );
}